import {combineReducers} from 'redux';
import {lotReducer} from './lot';
import {pickupFormReducer} from './pickupForm';
import {stepperReducer}  from './stepper';
import {addressReducer}  from './address';
import {infoHelpReducer}  from './infoHelp';
import {uiReducer}  from './ui';
import {notificationReducer}  from './notification';

export const reducers = combineReducers({
  lot: lotReducer,
  pickupForm: pickupFormReducer,
  address: addressReducer,
  stepper: stepperReducer,
  infoHelp: infoHelpReducer,
  ui: uiReducer,
  notification: notificationReducer
});



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js